<template>
  <div class='history-detail'>
    <div data-v-58b7664a="" class="history-popper-header">
      <div data-v-58b7664a="" class="ivu-row-flex ivu-row-flex-space-between">
        <div data-v-58b7664a="" class="ivu-col ivu-col-span-22" type="flex">
          <b data-v-58b7664a="" class="game-title">
            {{ roundData.name }}
          </b>
        </div>
        <div data-v-58b7664a="" class="history-popper-header-close ivu-col ivu-col-span-2">
          <a data-v-58b7664a="" class="close" @click="closePopover" >
            
          </a>
        </div>
      </div>
      <div data-v-58b7664a="" class="ivu-row">
        <div data-v-58b7664a="" class="history-draw-no ivu-col" alig="center">
          {{ $t('no.') }} {{ roundData.round }}
        </div>
      </div>
      <div data-v-58b7664a="" class="ivu-row">
        <div data-v-58b7664a="" class="history-draw-time ivu-col" alig="center">
          {{ roundData.createdDate }}
        </div>
      </div>
    </div>
    <div data-v-58b7664a="" class="draw-cont">
      <div data-v-58b7664a="" class="numtiles-cont">
        <div data-v-58b7664a="" class="numtiles-cont-space draw-result">
          <!-- <div data-v-58b7664a="" class="tile black red">
            4
          </div> -->
          <div data-v-58b7664a="" class="tile"
            v-for="i in dices"
            :key="i"
            :class="classObject(getItemValue(i))"
          >
            {{ getItemValue(i) }}
          </div>
        </div>
      </div>
      <div data-v-58b7664a="" class="summary-detail totalsum">
        <span data-v-58b7664a="">{{ $t('sum') }}</span>
        <span data-v-58b7664a="" class="detailvalue">
          {{ roundData.score.mainTotal }}
        </span>
      </div>
      <div data-v-58b7664a="" class="summary-detail row1">
        <span data-v-58b7664a="" class="detailvalue">
          {{ roundData.score.L1total }}
        </span>
      </div>
      <div data-v-58b7664a="" class="summary-detail row2">
        <span data-v-58b7664a="" class="detailvalue">
          {{ roundData.score.L2total }}
        </span>
      </div>
      <div data-v-58b7664a="" class="summary-detail row3">
        <span data-v-58b7664a="" class="detailvalue">
          {{ roundData.score.L3total }}
        </span>
      </div>
      <div data-v-58b7664a="" class="summary-detail row4">
        <span data-v-58b7664a="" class="detailvalue">
          {{ roundData.score.L4total }}
        </span>
      </div>
      <div data-v-58b7664a="" class="summary-detail row5">
        <span data-v-58b7664a="" class="detailvalue">
          {{ roundData.score.L5total }}
        </span>
      </div>
    </div>
    <div data-v-58b7664a="" class="result-rows">
      <div data-v-58b7664a="" class="second-row-number ivu-row-flex ivu-row-flex-space-between">
        <div data-v-58b7664a="" class="trendstat ivu-col ivu-col-span-8"
          v-for="i in resultArray"
          :key="i"
        >
          {{ getValue(i) }}
        </div>
      </div>
    </div>
    <div x-arrow="" class="popper__arrow" style="left: 220px;"></div>
  </div>
</template>

<script>
import { isRed } from '@utils/dice.js';

const RESULT_ARRAY = [
  'bigSmall', 'oddEven', 'redBlack', 'highLow',
  'L1bigSmall' , 'L1oddEven' , 'L1redBlack' , 'L1highLow',
  'L2bigSmall' , 'L2oddEven' , 'L2redBlack' , 'L2highLow',
  'L3bigSmall' , 'L3oddEven' , 'L3redBlack' , 'L3highLow',
  'L4bigSmall' , 'L4oddEven' , 'L4redBlack' , 'L4highLow',
  'L5bigSmall' , 'L5oddEven' , 'L5redBlack' , 'L5highLow',
  'season',
];

export default {
  props: {
    roundData: {
      type: Object,
      default: () => ({
        name: { type: String, default: "" },
        value: { type: String, default: "" },
        round: { type: Number, default: 0 },
        score: { type: Object, default: () => ({})},
        createdDate: { type: String, default: "" },
      })
    }
  },
  data() {
    return {
      resultArray: RESULT_ARRAY,
    }
  },
  computed: {
    dices()  {
      return Array.from(Array(25).keys());
    },
    tableDices()  {
      return this.roundData.score.resultRaw.result;
    },
  },
  methods: {
    closePopover() {
      console.log('HistoryDetail - closePopover');
      this.$emit('closePopover');
    },
    classSuit: function(value) {
      
      
    },
    classWinLoss: function(value) {
      return this.score.result === value ? "bacarat-win" : "bacarat-loss";
    },
    classNumberColor: function(suit) {
      return suit > 2 ? "flipResult-barh-card-number-red" : "flipResult-barh-card-number-black";
    },
    getValue (key) {
      return this.$t('result_map.' + this.roundData.score[key]);
    },
    getItemValue (id) {
      const i = Math.floor(id / 5);
      const j = id % 5;
      const result = this.tableDices[i][j];
      return result;
    },
    classObject (number){
      if(number < 0){
        return '';
      }
      const result = isRed(number);
      return result ? 'red' : 'black';
    },
  }
}
</script>

<style>
   
</style>
